<template>
  <div>
    <div class="ui-wrap">
      <div class="ui-box">
        <div class="head">常见问题</div>
        <ul class="list">
          <li v-for="(item, index) in list" :key="index" :class="{open: index === current}">
            <div class="item">
              <p class="title" @click="current = index">{{item.title}}</p>
              <div class="answer" v-show="index === current">
                <p v-html="item.info"></p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Platform />
  </div>
</template>
<script>
import Platform from '@/components/Platform.vue'
import {getFaqList, getFaq} from '@/service/api.js'
export default {
  components: {Platform},
  data(){
    return {
      list: [],
      current: 0
    }
  },
  created(){
    this.getList()
  },
  methods: {
    async getList(){
      let res = await getFaqList()
      if(res.data.status === 1){
        let data = res.data.data
        for(let i = 0; i < data.length; i ++){
          this.list[i] = {}
          this.getFaq(i, data[i].id)
        }
      }else{
        alert(res.data.descript)
      }
    },
    async getFaq(index, id){
      let res = await getFaq({id: id})
      if(res.data.status === 1){
        this.list[index].title = res.data.data.title
        this.list[index].info = res.data.data.content
      }
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss" scoped>
.head{padding: 47px 0 41px; line-height: 42px; font-size: 32px; text-align: center; border-bottom: 1px solid #D6D6D6;}
.list{
  padding: 0 80px 100px;
  li{
    border-bottom: 1px solid #D6D6D6; 
    &:last-child{border-bottom: 0;}
    &.open{
      .title:after{transform: rotate(0deg);}
      .item{background: #f9f9f9;}
    } 
  }
  .item{padding: 50px 80px; margin: 0 -80px;}
  .title{
    font-size: 21px; cursor: pointer;
    &:after{content: ''; display: inline-block; width: 14px; height: 8px; background: url(../assets/arrow.png); vertical-align: middle; margin-left: 10px; transform: rotate(180deg);}
  }
  .answer{font-size: 16px; margin-top: 20px; color: #999;}
}
</style>